import { IMenuItem } from '@models/menu/menu-item';

export class ImportDialogTabs {
  private static readonly tabs: IMenuItem[] = [
    {
      label: 'Import Monthly Deposit Data',
      canDeactivate: true,
      outlet: 'import-outlet',
      routerLink: 'deposit-data'
    },
    {
      label: 'Import Market Rate Data',
      canDeactivate: true,
      outlet: 'import-outlet',
      routerLink: 'market-rate-data'
    }
  ];

  public static getDialogTabs() {
    return this.tabs;
  }
}
